import {
  MdOutlineMiscellaneousServices,
  MdOutlineSecurityUpdateGood,
} from "@onemind-services-llc/react-icons-ng/md";
import { GiCycle } from "@onemind-services-llc/react-icons-ng/gi";

export const ADVANTAGES_CONSTANTS = [
  {
    icon: MdOutlineMiscellaneousServices,
    title: "Core Services Covered",
    text: "Outlook, OneDrive, SharePoint, and Teams — all managed seamlessly in one place.",
  },
  {
    icon: MdOutlineSecurityUpdateGood,
    title: "Enterprise-Grade Security",
    text: "Data Loss Prevention (DLP), Microsoft Defender for M365, and Multi-Factor Authentication (MFA) are baked into every deployment for robust protection.",
  },
  {
    icon: GiCycle,
    title: "Full Lifecycle Management",
    text: "Comprehensive user onboarding and offboarding, policy setup, and admin support included as part of the service.",
  },
];
